import React, { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { Table, Button, Input, Switch, Select, Dropdown, Checkbox, Slider, Tooltip } from "antd";
import { ControlOutlined, FilterOutlined, ClearOutlined, CopyOutlined } from "@ant-design/icons";
import columns from "./columns";
import apiService from "./data";
import NoDataComponent from "../common/NoDataComponent";
import SimpleDrawer from "../SimpleProductsDetailView/SimpleDrawer";
import CreateProductDrawer from "../SimpleProductsDetailView/CreateProducts/CreateProductDrawer"
import FullPageLoader from "../common/FullPageLoader";
import ErrorNotification from "../common/ErrorNotification";
import globalData from "../../config/global_data";
import { exportToExcel } from "../MasterTable/exportToExcel";
import { useAuth } from "../UserAuth/AuthContext";
import { triggerNotification } from "../common/notify";
import common_api from "../../config/common_api";

const { Search } = Input;
const SimpleTable = ({ globalList, setGlobalList }) => {
  const [data, setData] = useState([]);
  const [originaldata, setOriginaldata] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [slectedStore, setSlectedStore] = useState("");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [CreatedrawerVisible, setCreateDrawerVisible] = useState(false);
  const [selectedDrawerdata, setSelectedDrawerdata] = useState({});
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stores, setstores] = useState([]);
  const [isloader, setisloader] = useState(true);
  const [alert, setAlert] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleColumnKeys, setVisibleColumnKeys] = useState(columns.map(col => col.dataIndex));
  const isAnyFilterApplied = searchText || (slectedStore && slectedStore !== "Select Store") || selectedFilter;
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100);
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 100]);
  const { userData } = useAuth();
  const tableWrapperRef = useRef(null);
  const [copiedSku, setCopiedSku] = useState(null);

  const activeFiltersCount = [
    searchText !== '',
    slectedStore && slectedStore !== 'all' && slectedStore !== 'Select Store',
    selectedFilter !== null,
    selectedPriceRange[0] !== minPrice || selectedPriceRange[1] !== maxPrice
  ].filter(Boolean).length;

  // const handleExport = () => {
  //   const selectedData = data.filter((item) =>
  //     selectedRowKeys.includes(item.key)
  //   );
  //   exportToExcel(selectedData);
  // };

  const handleExport = () => {
  const selectedData = data.filter((item) =>
    selectedRowKeys.includes(item.key)
  );

  const mappedData = selectedData.map((item) => {
    const msrp = item.prdouct_data?.prod_msrp;
    const salePrice = item.prdouct_data?.prod_sale_price;

    return {
      "Store": item.store,
      "Type": item.type,      
      "SAP SKU": item.sapSku,
      "BC Product (SKU)": item.bcSku,
      "BC Product Name": item.bc_name,
      "SAP Name": item.sapName,
      "Active on Store": item.active ? "True" : "False", 
      "BC Inventory": item.bcInventory,
      "SAP Price": item.sapPrice,
      "SAP MSRP": item.sapMsrp,
      "BC MSRP": msrp && msrp !== "0" ? item.currency_symbol + msrp : "NA",
      "BC Sale Price": salePrice && salePrice !== "0" ? item.currency_symbol + salePrice : "NA",
      "Available Stock": item.availableStock,
      "Reserved Stock": item.reservedStock,   
      "Subscription": item.subscription,
      "Enrichment": item.enrichment ? "True" : "False",
      "Last Updated": item.lastUpdated,
    };
  });

  exportToExcel(mappedData);
};


  const applyAllFilters = async (filters = {}) => {
    const {
      search = searchText,
      store = slectedStore,
      filter = selectedFilter,
      priceRange = selectedPriceRange,
      original = originaldata,
    } = filters;

    let filtered = await original;

    // Filter by store
    if (store !== "" && store !== "all" && store !== "Select Store") {
      filtered = filtered.filter(item =>
        item.store.toLowerCase().includes(store.toLowerCase())
      );
    }

    // Filter by search text

    if (search !== "") {
      filtered = await filtered.filter(item =>
        item.bcSku.toLowerCase().includes(search.toLowerCase()) ||
        item.bc_name.toLowerCase().includes(search.toLowerCase())
      );
    }



    switch (filter) {
      case "All":
        setSelectedPriceRange([minPrice, maxPrice]);
        break;
      case "Products not live":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.active === 0);
        break;
      case "Products live":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.active === 1);
        break;
      case "Enrichment pending":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.enrichment === false);
        break;
      case "Low Stock":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.bcInventory < 5 && item.bcInventory !== "NA");
        break;
      case "Price":
        filtered = filtered.filter(item => {
          const msrp = parseFloat(item?.prdouct_data?.prod_msrp?.replace(/[^0-9.]/g, ''));
          return !isNaN(msrp) && msrp >= priceRange[0] && msrp <= priceRange[1];
        });
        break;
      case "Gift Product":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.bcSku.toLowerCase().includes("gift"));
        break;
      case "Simple Product":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => !item.bcSku.toLowerCase().includes("gift"));
        break;
      case "Incomplete Mapping":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.sapSku === "NA");
        break;
      default:
        break;
    }
    setData(filtered);
    // setCurrentPage(1);
  };

  const fetchData = async () => {
    const apiData = await apiService.apidata();
    if (apiData && apiData.length > 0) {
      setGlobalList({ ...globalList, simple_datalist: apiData })
      await setData(apiData);
      await setOriginaldata(apiData);
      // For filter update after Save start 
      if (CreatedrawerVisible || drawerVisible) {
        applyAllFilters({ original: apiData });
      }
      // For filter update after Save End 
      setisloader(false);
      // Calculate min/max MSRP
      const msrps = apiData
        .map(item => parseFloat(item?.prdouct_data?.prod_msrp?.replace(/[^0-9.]/g, '')))
        .filter(price => !isNaN(price));

      if (msrps.length) {
        const min = Math.floor(Math.min(...msrps));
        const max = Math.ceil(Math.max(...msrps));
        setMinPrice(min);
        setMaxPrice(max);
        setSelectedPriceRange([min, max]);
      }
    } else {
      setisloader(false);
    }

  };
  const handleStorelist = async () => {
    if (globalData.store_list.length > 0) {
      setstores(globalData.store_list);
      setSlectedStore('Select Store');
    }
  }
  useEffect(() => {
    if (!globalList || !globalList.simple_datalist || globalList.simple_datalist.length <= 0) {
      fetchData();
    }
    const intr = setInterval(() => {
      if (globalData.store_list && globalData.store_list.length > 0) {
        clearInterval(intr)
        handleStorelist();
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (globalList && globalList.simple_datalist) {
      if (globalList.simple_datalist !== originaldata) {
        setData(globalList.simple_datalist);
        setOriginaldata(globalList.simple_datalist);
        applyAllFilters({ original: globalList.simple_datalist })
      }
      setisloader(false)
    }
  }, [globalList, originaldata]);
  const handleFilterChange = (value) => {
    setSelectedFilter(value);
    applyAllFilters({ filter: value, store: slectedStore });
  };

  const openDrawer = useCallback((bcSku, store_id) => {
    const filteredData = originaldata.filter((item) =>
      item.bcSku.toLowerCase() == bcSku.toLowerCase() && item.store_id === store_id
    );
    setSelectedDrawerdata(filteredData[0])
    setDrawerVisible(true)
  }, [originaldata]);

  const closeDrawer = () => setDrawerVisible(false);


  const CreateProductOpenDrawer = () => {
    setCreateDrawerVisible(true)
  };
  const CreateProductcloseDrawer = () => setCreateDrawerVisible(false);
  const handleSearch = (value) => {
    setSearchText(value);
    applyAllFilters({ search: value });
  };


  const handleStoreChange = (value) => {
    setSlectedStore(value);
    applyAllFilters({ store: value });
  };

  const handleToggleActive = useCallback(async (checked, key) => {
    setisloader(true);

    let filterdata = originaldata.find(item => item.key === key);
    let responsedata = await apiService.active_inactive_status(filterdata, checked);
    if (responsedata) {

      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
      if (alldata) {
        await setGlobalList(alldata)
      }
      setisloader(false);
      triggerNotification(responsedata)
    }
    setisloader(false);
  }, [originaldata, fetchData]);

  const updatedColumns = useMemo(() => {
    return columns
      .filter(col => visibleColumnKeys.includes(col.dataIndex))
      .map((col) => {
        if (col.dataIndex === "active") {
          return {
            ...col,
            render: (_, record) => (
              <Switch
                checked={record.active}
                disabled={userData.data?.access !== "ALL"}
                onChange={async (checked) => await handleToggleActive(checked, record.key)}
              />
            )
          };
        }
        if (col.dataIndex === "bcSku") {
          return {
            ...col,
            render: (_, record) => (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 1;
                }}
                onMouseLeave={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 0;
                }}
              >
                <Button type="link" onClick={(e) => openDrawer(record.bcSku, record.store_id)}>
                  {record.bcSku ? record.bcSku : "UPDATE"}
                </Button>
                <Tooltip title={copiedSku === record.bcSku ? "Copied" : "Copy"}>
                  <CopyOutlined
                    className="copy-icon"
                    onClick={() => {
                      navigator.clipboard.writeText(record.bcSku);
                      setCopiedSku(record.bcSku);
                      setTimeout(() => setCopiedSku(null), 1500);
                    }}
                    style={{
                      marginLeft: 6,
                      color: copiedSku === record.bcSku ? '#52c41a' : '#999',
                      cursor: 'pointer',
                      opacity: 0,
                      transition: 'opacity 0.3s ease, color 0.3s ease',
                    }}
                  />
                </Tooltip>
              </span>
            )
          };
        }
        return col;
      });
  }, [handleToggleActive, visibleColumnKeys, openDrawer, copiedSku]);

  const handleColumnChange = (dataIndex) => {
    setVisibleColumnKeys((prevKeys) =>
      prevKeys.includes(dataIndex)
        ? prevKeys.filter((key) => key !== dataIndex)
        : [...prevKeys, dataIndex]
    );
  };

  const columnMenu = {
    items: columns.map(col => ({
      key: col.dataIndex,
      label: (
        <Checkbox
          checked={visibleColumnKeys.includes(col.dataIndex)}
          onChange={(e) => handleColumnChange(col.dataIndex)}
        >
          {col.title}
        </Checkbox>
      ),
    })),
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }} className="TableFilterBox">
        {userData?.data?.access === "ALL" && (
          <Button type="primary" onClick={CreateProductOpenDrawer}>
            Create Product
          </Button>
        )}
        <Select
          placeholder="Filter"
          style={{ width: 180 }}
          suffixIcon={<FilterOutlined style={{ color: "rgba(0, 0, 0, 0.88)" }} />}
          value={selectedFilter}
          className="filterSelect"
          onChange={handleFilterChange}
          options={[
            { value: "All", label: "All" },
            { value: "Products not live", label: "Products not live" },
            { value: "Products live", label: "Products live" },
            { value: "Incomplete Mapping", label: "Incomplete Mapping" },
            { value: "Enrichment pending", label: "Enrichment pending" },
            { value: "Low Stock", label: "Low Stock" },
            { value: "Price", label: "Price" },
            { value: "Gift Product", label: "Gift Product" },
            { value: "Simple Product", label: "Simple Product" }
          ]}
        />

        {selectedFilter === "Price" && (
          <Slider
            className="rangeSlider"
            range
            step={1}
            min={minPrice}
            max={maxPrice}
            value={selectedPriceRange}
            onChange={(value) => {
              setSelectedPriceRange(value);
              applyAllFilters({ priceRange: value });
            }}
          />
        )}
        <Select
          placeholder="Stores"
          style={{ width: 120 }}
          value={slectedStore}
          options={stores}
          onChange={handleStoreChange}
        />
        <Search
          placeholder="Search by BC SKU or Name"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 270 }}
          allowClear
          enterButton
        />
        {isAnyFilterApplied && (
          <Button
            onClick={() => {
              setSearchText('');
              setSlectedStore('Select Store');
              setSelectedFilter(null);
              setSelectedPriceRange([minPrice, maxPrice]); // Reset slider
              setData(originaldata);
              // setCurrentPage(1); 
            }}
            className="ClearAllFiltersBtn"

          >
            <ClearOutlined style={{ marginRight: 4 }} />
            {activeFiltersCount === 1 ? 'Clear Filters' : 'Clear Filters'}
          </Button>
        )}
        <Dropdown menu={{ ...columnMenu, className: 'ColumnMenuClass' }} trigger={["click"]} placement="bottomRight" className="TableSettings">
          <Button icon={<ControlOutlined />} />
        </Dropdown>
        <div className="RightBox">
          <Button type="primary" disabled={selectedRowKeys.length <= 0} onClick={handleExport}>
            Export Selected
          </Button>
        </div>
      </div>

      <FullPageLoader isloader={isloader} />
      <ErrorNotification {...alert} />
      <div
        className="TableBox"
        ref={tableWrapperRef}
        style={{ maxHeight: 700, overflow: 'auto' }}
      >
        {data && data.length > 0 ? <Table
          columns={updatedColumns}
          dataSource={data}
          scroll={{ x: '100%', y: 500 }}
          rowSelection={rowSelection}
          pagination={{
            current: currentPage,
            pageSize,
            total: data.length,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
            showTotal: (total) =>
              `Total ${total} items${selectedRowKeys.length > 0 ? ` | Selected: ${selectedRowKeys.length}` : ''}`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            position: ['bottomLeft']
          }}
          bordered
        /> :
          <div>
            <NoDataComponent />
          </div>}
      </div>

      {drawerVisible && <SimpleDrawer onProductCreate={fetchData} visible={drawerVisible} onClose={closeDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}

      {CreatedrawerVisible && <CreateProductDrawer onProductCreate={fetchData} visible={CreatedrawerVisible} onClose={CreateProductcloseDrawer} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}

    </div>
  );
};

export default SimpleTable;
